import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ClientTableComponent } from '../../components/client-table/client-table.component';
import { Permission } from '@shared/enums/permission.enum';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { PermissionService } from '@core/services/permission.service';
import { ClientResponse } from '../../client.model';
import { ClientStore } from '../../client.store';
import {SHARED_IMPORTS} from "../../../../shared/modules/shared-imports.module";
import { SHARED_UTILS } from '@shared/modules/shared-utils.module';

@Component({
  selector: 'app-client-list-page',
  imports: [ClientTableComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './client-list.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientListPage {
  private readonly permissionService = inject(PermissionService);
  protected readonly clientStore = inject(ClientStore);

  protected readonly actionClientId = signal<string | null>(null);

  protected readonly utils = SHARED_UTILS();

  constructor() {
    this.clientStore.loadClients({ includeInactive: true });
  }

  protected canCreate(): boolean {
    return this.permissionService.hasPermission(Permission.ClientsCreate);
  }

  protected canManageCompanies(): boolean {
    return this.permissionService.hasPermission(Permission.CompaniesRead);
  }

  protected canDelete(): boolean {
    return this.permissionService.hasPermission(Permission.ClientsDelete);
  }

  protected canUpdate(): boolean {
    return this.permissionService.hasPermission(Permission.ClientsUpdate);
  }

  protected toggleClientActive(client: ClientResponse): void {
    this.actionClientId.set(client.id);

    if (client.isActive) {
      this.clientStore.deactivateClient(client.id, () => {
        this.clientStore.loadClients({ includeInactive: true });
        this.actionClientId.set(null);
      });

      return;
    }

    this.clientStore.activateClient(client.id, () => {
      this.clientStore.loadClients({ includeInactive: true });
      this.actionClientId.set(null);
    });
  }
}